import { Question } from 'libs/modules/tunnelsante/components/insurances/health-quotation-formB2C/factory-age-validators';
import { AddressModels } from './address.models';
import { CommonRiskModels } from './common-risk.models';
import { CommonModels } from './common.models';
import { DocumentModels } from './document.models';
import { HealthRiskModels } from './health-risk.models';
import { PolicyModels } from './policy.models';
import { QuotationModels } from './quotation.models';

export namespace HealthModels {
  export interface HealthPolicyPricingMetadatas
    extends PolicyModels.PolicyPricingMetadatas {
    formulas: { [formula: number]: HealthFormulaMetadata };
    healthRateLinear: HealthModels.HealthRateLinearEnum;
    healthRateWithholding: HealthModels.HealthRateWithholdingEnum;
    isWithholdingThresholdExceeded: boolean;
  }

  export interface HealthFormulaMetadata extends PolicyModels.FormulaMetadata {
    universBesoinNotes: UniversBesoinNote[];
  }

  export interface UniversBesoinNote {
    type: UniversBesoinTypeEnum;
    value: number;
    metricType: 'euro' | 'percentage';
  }

  export interface QuotationRequest {
    risk: HealthRiskModels.Risk;
    formula?: QuotationModels.FormulaEnum;
    packageId?: number;
    brokerLoading?: number;
    brokerFees?: number;
    controlListeParam: Question[];
    quotationParamOrigin?: string;
    quotationCodeOrigin?: string;
    quotationCodeParrain?: string;
    quotationBaseOrigin?: string;
    quotationAcceptCompMT?: string;
    quotationNavigator?: QuotationModels.Navigator;
    commissionType?: QuotationModels.CommissionTypeEnum;
    optionalWarranties?: QuotationModels.WarrantyEnum[];
    staggering?: QuotationModels.QuittancementEnum;
    tarifPrix?: string;
    codeFormule?: string;
    TypeProduit?: string;
  }

  export interface QuotationSummary {
    status: QuotationModels.QuotationStatusEnum;
    periodicPricing: number;
    risk: HealthRiskModels.Risk;
    files: { [key: number]: string };
    formulaChoice: QuotationModels.FormulaChoice;
    brokerFeesChoice: QuotationModels.BrokerFeesChoice;
    publicId: string;
    creationDate: string;
    signatureReadyDate?: string;
    tarifier?: string;
    leadId?: string;
    staggering: QuotationModels.QuittancementEnum;
    rib: FinancialInfo;
    isWithholdingThresholdExceeded: boolean;
    package: PolicyModels.PackageEnum;
    tarifPrix?: string;
    codeFormule?: string;
    TypeProduit?: string;
  }

  export interface FinancialInfo {
    mainRib: DocumentModels.RibInformation;
    refundRib?: DocumentModels.RibInformation;
    quantieme: number;
  }

  export interface HealthQuotationStoredData {
    quotationForm: HealthModels.QuotationForm;
    subscriptionForm?: HealthModels.SubscriptionForm | any;
    brokerFees: QuotationModels.BrokerFeesChoice | any;
    controlListeParam: Question[]; //Data we gonna fill, when we answer question on Formulaire devis (page 1)
    formulaChoice: QuotationModels.FormulaChoice;
    currentStaggering: QuotationModels.QuittancementEnum | any;
    quotationNavigator: QuotationModels.Navigator;
    quotationCreationDate?: string;
    quotationParamOrigin?: string;
    quotationCodeOrigin?: string;
    quotationCodeParrain?: string;
    quotationBaseOrigin?: string;
    quotationAcceptCompMT?: string;
    signatureReadyDate?: Date;
    tarifier?: string;
    leadId?: string;
    package: PolicyModels.PackageEnum;

    tarifPrix?: string;
    codeFormule?: string;
    TypeProduit?: string;
  }

  export interface QuotationForm {
    assureInfos?: CommonRiskModels.AssureInfos;
    assurePrincipal: Assure;
    family: Family;
    universBesoinInfo: UniversBesoinInfo;
    vadInfo: VadInfo;
  }

  export interface VadInfo {
    isVad?: boolean;
    saleType?: SaleTypeEnum;
    isCallFromProspect?: boolean;
    isRappel?: boolean;
    isBloctel?: boolean;
    toggleBloctel?: boolean;
    toggleVad?: boolean;
    signatureReadyDate?: string;
    tarifier?: string;
    gclid?: string;
    msclkid?: string;
    origin?: string;
    leadId?: string;
    tarifsTout?: Tarif[];
    tarif_Selected?: Tarif;
    rang?: number;
  }

  export interface Resilisation {
    kindOfContractId?: string;
    cancelReasonId?: string;
    clientHasAlreadyHealthPolicy?: boolean;
    isMoreThan12Month?: boolean;
    currentContractCarrierId?: number;
    currentContractCarrierName?: string;
    currentContractNumber?: string;
  }

  export interface Assure {
    groupVille?: AddressModels.GroupVille;
    dateNaissance: string;
    dateEffet?: string | any;
    regimeSocial: RegimeSocialEnum;
  }

  export interface UniversBesoinInfo {
    hasAlreadyHealthContract: boolean;
    healthContractName?: string;
    monthlyBudget?: number;
    formula: QuotationModels.FormulaEnum;
    questions?: HealthModels.UniversBesoinQuestionResponse[];
  }

  export interface Family {
    conjoint?: FamilyPerson;
    enfants: FamilyPerson[];
  }

  export interface FamilyPerson {
    dateNaissance: string;
    regimeSocial: RegimeSocialEnum;
    isRegimeSocialDifferent: boolean;
    isDisabled: boolean;
  }

  export interface SubscriptionForm {
    assurePrincipal: SubscriptionAssure;
    conjoint: SubscriptionFamilyPerson;
    enfants: SubscriptionFamilyPerson[];
    financial: SubscriptionFinancialInfo;
    vadInfos: VadInfo;
    ria: Resilisation;
  }

  export interface SubscriptionFinancialInfo {
    mainRib: DocumentModels.RibInformation;
    isRefundRibDifferent: boolean;
    refundRib?: DocumentModels.RibInformation;
    quantieme: number;
  }

  export interface SubscriptionAssure extends NumberInfos {}

  export interface SubscriptionFamilyPerson extends NumberInfos {
    prenom: string;
    nom: string;
    civilite: CommonModels.CivilityEnum;
    beneficiaryOf?: BeneficiaryTypeEnum;
    isDisabled?: boolean;
  }

  export interface NumberInfos {
    numeroSS: string;
    numeroOrganismeAffiliation: string | any;
  }

  export interface HealthSignatureInfo {
    disableSmsForElectronicSignature: boolean;
    email: string;
    mobile: string;
    membershipApplicationUrl: string;
    allowEletronic: boolean;
    package: PolicyModels.PackageEnum;
  }

  export interface UniversBesoinQuestionResponse {
    type: UniversBesoinTypeEnum;
    level: UniversBesoinLevelEnum;
  }

  export enum UniversBesoinTypeEnum {
    Medecine = 1,
    Hospitalisation = 2,
    Optique = 3,
    Dentaire = 4,
    Pharmacie = 5,
    BienEtre = 6,
    AvantageCapitalDC = 7,
    Auditif = 8,
  }

  export enum UniversBesoinLevelEnum {
    Low = 1,
    Medium,
    High,
    VeryHigh,
  }

  //Type dans Webservice IGD
  export enum BesoinsTypeIGDEnum {
    Auditif = 'Auditif',
    Dentaire = 'Dentaire',
    Hospitalisation = 'Hospitalisation',
    Medecin = 'Medecin',
    Optique = 'Optique',
  }

  //Niveau des besoins
  //Dans IGD: NonRenseigne = 0, Aucun = 1, Minimum = 2, Moyen = 3, Fort = 4, Maximum = 5
  export enum NiveauBesoinsIGDEnum {
    NonRenseigne = 0,
    Aucun = 1,
    Minimum = 2,
    Moyen = 3,
    Fort = 4,
    Maximum = 5,
  }

  export enum RegimeSocialIGDEnum {
    SecuriteSocial = 0, //Régime generale
    TravailleurNonSalarie = 1,
    ExploitantAgricole = 2,
    AlsaceMoselle = 3,
    G = 4,
    // SalarieAgricole = 4,
    // Etudiant = 5,
    // SecuriteSoscialAgricole = 6
  }

  export function RegimeSocialConverter(regime: RegimeSocialIGDEnum) {
    switch (regime) {
      case RegimeSocialIGDEnum.SecuriteSocial:
        return 'SS';
        break;
      case RegimeSocialIGDEnum.TravailleurNonSalarie:
        return 'TNS';
        break;
      case RegimeSocialIGDEnum.ExploitantAgricole:
        return 'ExAgricole';
        break;
      case RegimeSocialIGDEnum.AlsaceMoselle:
        return 'AlsaceMoselle';
        break;
      case RegimeSocialIGDEnum.G:
        return 'G';
      default:
        return 'SS';
        break;
    }
  }

  export enum RegimeSocialEnum {
    General = 1,
    Agricole = 2,
    TNS = 3,
    AlsaceMoselle = 4,
    // CaisseFrancaisEtranger = 5,
    // HorsSecuriteSociale = 6
  }

  export enum SaleTypeEnum {
    Remote = 1,
    FaceToFace,
    DoorToDoor,
  }

  export interface FormulaUniversBesoinStorage {
    valueMetricType?: 'percentage' | 'euro';
    universType: HealthModels.UniversBesoinTypeEnum;
    value: number | { withDPTAM: number; withoutDPTAM: number };
  }

  export interface FormulaUniversBesoin
    extends FormulaUniversBesoinStorage,
      UniversBesoinMetrics {
    value: number;
    valueMetricType: 'percentage' | 'euro';
    headerMetricType: 'percentage' | 'euro';
  }

  export interface UniversBesoinMetrics {
    maximum: number;
    headerMetricType: 'percentage' | 'euro';
  }

  export enum BeneficiaryTypeEnum {
    You = 1,
    Partner = 2,
  }

  export enum TerminationCategoryEnum {
    Resiliation = 1,
    SansEffet = 2,
  }

  export enum PolicyHolderTypeEnum {
    AssurePrincipal = 1,
    Conjoint = 2,
    Enfant = 3,
  }

  export enum HealthRateLinearEnum {
    L1 = 1,
    L2 = 2,
    L3 = 3,
    L4 = 4,
    L5 = 5,
    L6 = 6,
    L7 = 7,
    L8 = 8,
    L9 = 9,

    L_24_16 = 10,
    L_24_18 = 11,
    L_24_20 = 12,
    L_22_16 = 13,
    L_22_18 = 14,

    FIDELITY_L_24_16 = 18,
    FIDELITY_L_24_18 = 19,
    FIDELITY_L_24_20 = 20,

    ACHEEL_L1 = 15,
    ACHEEL_L2 = 16,
    ACHEEL_L7 = 17,
  }

  export enum HealthRateWithholdingEnum {
    PR1 = 1,
    PR2 = 2,
    PR3 = 3,
    PR4 = 4,
    PR5 = 5,
    PR6 = 6,
    PR7 = 7,

    PR_25_15_16 = 8,
    PR_27_15_16 = 9,
    PR_30_15_17 = 10,
    PR_32_16_17 = 11,
    PR_35_16_17 = 12,
    PR_37_15_17 = 13,

    FIDELITY_PR_32_10_10 = 21,
    FIDELITY_PR_42_10_10 = 22,
    FIDELITY_PR_45_10_10 = 23,
    FIDELITY_PR_35_10_10 = 24,
    FIDELITY_PR_37_10_10 = 25,
    FIDELITY_PR_40_10_10 = 26,

    ACHEEL_PR1_50_15 = 14,
    ACHEEL_PR2_50_15 = 15,
    ACHEEL_PR3_50_15 = 16,
    ACHEEL_PR4_50_15 = 17,
    ACHEEL_PR5_50_15 = 18,
    ACHEEL_PR6_50_15 = 19,
    ACHEEL_PR7_50_15 = 20,
  }

  export enum HealthRateCommissionPairsEnum {
    L1PR1 = 1,
    L1PR5 = 2,
    L2PR6 = 3,
    L2PR7 = 4,
    L2PR2 = 5,
    L7PR3 = 6,
    L7PR4 = 7,

    L_24_16_PR_25_15_16 = 8,
    L_24_16_PR_27_15_16 = 9,
    L_24_18_PR_30_15_17 = 10,
    L_24_18_PR_32_16_17 = 11,
    L_24_20_PR_35_16_17 = 12,
    L_24_20_PR_37_15_17 = 13,

    FidelityL_24_16_PR_32_10 = 21,
    FidelityL_24_16_PR_35_10 = 22,
    FidelityL_24_18_PR_37_10 = 23,
    FidelityL_24_18_PR_40_10 = 24,
    FidelityL_24_20_PR_42_10 = 25,
    FidelityL_24_20_PR_45_10 = 26,

    AcheelL1PR1 = 14,
    AcheelL1PR5 = 15,
    AcheelL2PR6 = 16,
    AcheelL2PR7 = 17,
    AcheelL2PR2 = 18,
    AcheelL7PR3 = 19,
    AcheelL7PR4 = 20,
  }

  export interface DirectDebitFileTableRow {
    id: number;
    userName: string;
    fileName: string;
    creationDate: Date;
    isSuccess?: boolean;
    executionDate?: Date;
    payload: string;
  }

  export interface DirectDebitFormModel {
    files: File[];
  }

  export interface RejectFileTableRow {
    id: number;
    creationDate: Date;
    executionDate?: Date;
    executionUser?: string;
    fileName: string;
    fileUrl: string;
    isMarkingAsDone: boolean;
    errors: string[];
  }

  export interface HealthAssureForm {
    groupVille?: AddressModels.GroupVille;
  }

  export enum HealthContactTypeEnum {
    RiskBearingInsurer = 1,
    Assistant,
    ServiceManagement,
  }

  export interface ReponseAfiExport {
    IsDoublon?: string;
    Tarifs?: Tarif[];
    tarifsTout?: Tarif[];
  }

  export interface Tarif {
    codeFormule?: string;
    iD_Cotation?: string;
    iD_Formule?: string;
    isComplet?: string;
    montant?: string;
    ordre?: string;
    produitTarif?: string;
    urlSouscription?: string;
  }
}
